import api from './api';

// Interface base para Agencia
export interface Agencia {
  id: number;
  nome: string;
  dataremocao?: string;
  principal_id?: number;
}

// Interface para criação de Agencia
export interface AgenciaCreate {
  nome: string;
  principal_id?: number;
}

// Interface para atualização de Agencia
export interface AgenciaUpdate {
  nome?: string;
  principal_id?: number;
}

// Interface para filtros de busca
export interface AgenciaFilter {
  nome?: string;
  principal_id?: number;
}

const AgenciasService = {
  // Obter lista de agências com filtragem e paginação
  getAgencias: async (filter: AgenciaFilter = {}, skip: number = 0, limit: number = 10): Promise<Agencia[]> => {
    try {
      const response = await api.get('/agencias/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar agências:', error);
      throw error;
    }
  },

  // Obter agência por ID
  getAgenciaById: async (id: number): Promise<Agencia> => {
    try {
      const response = await api.get(`/agencias/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar agência ${id}:`, error);
      throw error;
    }
  },

  // Criar nova agência
  createAgencia: async (agencia: AgenciaCreate): Promise<Agencia> => {
    try {
      const response = await api.post('/agencias/', agencia);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar agência:', error);
      throw error;
    }
  },

  // Atualizar agência existente
  updateAgencia: async (id: number, agencia: AgenciaUpdate): Promise<Agencia> => {
    try {
      const response = await api.put(`/agencias/${id}`, agencia);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar agência ${id}:`, error);
      throw error;
    }
  },

  // Excluir agência
  deleteAgencia: async (id: number): Promise<void> => {
    try {
      await api.delete(`/agencias/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir agência ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getAgenciasCount: async (filter: AgenciaFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/agencias/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de agências:', error);
      throw error;
    }
  },
  
  // Obter todas as agências (para uso em dropdowns)
  getAllAgencias: async (): Promise<Agencia[]> => {
    try {
      const response = await api.get('/agencias/all/list');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar todas as agências:', error);
      throw error;
    }
  }
};

export default AgenciasService;
